import React, {useEffect, useRef, useState} from "react";
import {Upload, Button, message} from "antd";
import {
    InboxOutlined,
} from '@ant-design/icons';
import { fileUpload } from "../../util/request";
import { v4 as uuidv4 } from 'uuid';
import {GLOBAL_CONNECTION_API} from "../../config/api";
import UploadProgressModal from "./UploadProgressModal";
import {
    UploadOutlined,
} from '@ant-design/icons';
import './style/customUploader.less';


const { Dragger } = Upload;
const MAX_SIZE = 2048;   // 上传文件最大大小 单位：MB

interface AttachmentUploaderProps {
    className?: string;
    type?: 'default' | 'dragger',    // default: 普通上传按钮 dragger: 可拖拽上传
    style?: any;
    beforeUpload?: (file: any, fileList: any[]) => boolean;    // 上传文件之前的钩子
    onChange?: (value: any[]) => void;
}


/**
 * 自定义文件上传表单组件
 * @param props
 * @constructor
 */
const Uploader = (props: AttachmentUploaderProps) => {
    const { className = '', type = 'default', style, onChange = (value: any) => {}, beforeUpload = () => true } = props;
    // 上传进度
    const [fileList, setFileList] = useState<any[]>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const fileListRef = useRef<any[]>([]);
    // 文件数量
    const countRef = useRef<number>(0);


    useEffect(() => {
        return () => {
            countRef.current = 0;   // 文件数量归零
        }
    }, [])


    /**
     * 更新文件列表
     * @param data
     */
    const updateFileList = (data: any[]) => {
        fileListRef.current = data;
        setFileList(data);
    }


    /**
     * 更新文件信息
     * @param attachmentId
     * @param info
     */
    const updateFileInfo = (attachmentId: string, info: any) => {
        let fileList = fileListRef.current.map((v: any) => v.attachmentId === attachmentId ? {...v, ...info} : v);
        updateFileList(fileList);
    }


    /**
     * 上传文件
     * @param files
     */
    const upload = (e: any) => {
        const { file } = e;
        const { name, size } = file;

        if (size > MAX_SIZE * 1024 * 1024) {
            message.warning(`文件"${name}"体积过大，只能上传${MAX_SIZE}MB以内的文件`);
            return;
        }

        let attachmentId = uuidv4();
        let newFiles = [...fileListRef.current, {attachmentId, name, status: 'uploading'}];
        countRef.current += 1;  // 文件数量加一
        updateFileList(newFiles);
        setVisible(true);

        fileUpload('/attachment/upload', file, 'file',
{
            baseURL: GLOBAL_CONNECTION_API,
            onUploadProgress: (progressEvent: any) => {
                const { loaded, total } = progressEvent;
                updateFileInfo(attachmentId, {loaded, total});
            },
        }
        ).then((res: any) => {
            updateFileInfo(attachmentId, {status: 'success', fileInfo: res.data});
        }).catch(() => {
            updateFileInfo( attachmentId, {status: 'error'});
        }).finally(() => {
            countRef.current -= 1;
            // 所有文件都上传完毕
            if (countRef.current === 0) {
                onChange([...fileListRef.current.filter((v: any) => v.fileInfo).map((v: any) => v.fileInfo)]);
                setVisible(false);
                updateFileList([]);
            }
        });
    }


    const getBtn = (): React.ReactNode=> {
        if (type === 'default') {
            return (
                <Upload
                    multiple={true}
                    beforeUpload={beforeUpload}
                    customRequest={upload}
                    showUploadList={false}
                >
                    <Button className="button-red" type="primary" size="small" icon={<UploadOutlined />}>上传附件</Button>
                </Upload>
            )
        }
        if (type === 'dragger') {
            return (
                <Dragger
                    multiple={true}
                    beforeUpload={beforeUpload}
                    customRequest={upload}
                    showUploadList={false}
                    style={{width: 400}}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="f12">点击或拖拽文件上传</p>
                </Dragger>
            )
        }
        return null;
    }


    return (
        <div className={['custom-uploader-core-wrap', className].join(' ')}>
            {getBtn()}
            <UploadProgressModal visible={visible} dataSource={fileList} />
        </div>
    )
}


export default Uploader;
